import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { INSTRUMENTS_QUERY_KEY } from "./useInstruments";

type InstrumentResponse = components["schemas"]["InstrumentResponse"];

export type RestoreInstrumentVariables = {
  instrumentId: string;
};

export function useRestoreInstrument() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<InstrumentResponse, Error, RestoreInstrumentVariables>({
    mutationFn: async ({ instrumentId }) => {
      const { data, error } = await client.POST(
        "/api/instruments/{instrument_id}/restore",
        {
          params: { path: { instrument_id: instrumentId } },
        },
      );
      if (error !== undefined) {
        throw new Error(`Failed to restore instrument ${instrumentId}`);
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: INSTRUMENTS_QUERY_KEY });
    },
  });
}
